import { render, staticRenderFns } from "./WareMoreSoft.vue?vue&type=template&id=1ea92bf0&scoped=true&"
import script from "./WareMoreSoft.vue?vue&type=script&lang=js&"
export * from "./WareMoreSoft.vue?vue&type=script&lang=js&"
import style0 from "./WareMoreSoft.vue?vue&type=style&index=0&id=1ea92bf0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea92bf0",
  null
  
)

export default component.exports